
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-interview",
      function () {
        return require("private-next-pages/upsc-interview/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-interview"])
      });
    }
  